import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { hasObjectKeys } from '../main';

export const createLayer = layerName => {
  const vectorLayer = new LayerVector({});
  vectorLayer.setProperties({ layerName });

  return vectorLayer;
};

export const getLayerByName = (map, layerName) => {
  if (!map || !hasObjectKeys(map)) return;
  const layer = map
    .getLayers()
    .getArray()
    .find(mapLayer => mapLayer.getProperties().layerName === layerName);

  return layer || null;
};

export const removeLayerIfExists = (map, layer) => {
  if (
    !map ||
    !Object.keys(map).length ||
    !map.getLayers().getLength() ||
    !layer
  )
    return;
  map.removeLayer(layer);
};

export const addFeaturesToLayer = (layer, features) => {
  if (!layer || !features) return;
  if (layer.getSource()) layer.getSource().addFeatures(features);
  else {
    const vectorSource = new SourceVector({
      features,
    });
    layer.setSource(vectorSource);
  }
};

export const clearMapLayer = layer => {
  if (!layer) return;
  if (layer.getSource()) layer.getSource().clear();
};

// working both for one geometry and array of geometries
export const addFeaturesToLayerUsingGeojsonGeometry = (layer, geometry) => {
  if (!layer || !geometry) return;

  layer.setSource(createVectorSourceUsingGeojsonGeometry(geometry));
};

export const createVectorSourceUsingGeojsonGeometry = geometry => {
  if (!geometry) return;
  const parser = new GeoJSON();
  const feature = parser.readFeatures(geometry, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
  });
  const vectorSource = new SourceVector({ format: new GeoJSON() });
  vectorSource.addFeatures(feature);
  return vectorSource;
};

export const createFeatureUsingGeojsonGeometry = geometry => {
  if (!geometry) return;
  const parser = new GeoJSON();
  const feature = parser.readFeature(geometry, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
  });
  return feature;
};

export const getAllLayerFeatures = layer => {
  if (!layer) return [];
  const source = layer.getSource();
  return source ? source.getFeatures() : [];
};

export const hasLayerSource = layer => layer.getSource() || null;
